module.exports = __webpack_public_path__ + "static/media/Crystal.f76904da.jpg";